import { useCallback } from "react";

import { Run, Stack } from "types/generated";
import useHasStackWriteAccess from "shared/Stack/access/useHasStackWriteAccess";

import { isRunDiscardable } from "../useDiscardRun/accessValidation";

// Check if the user can discard the run based on the run
const useCanDiscardRun = (initialStack?: Stack): ((run: Run, stack?: Stack) => boolean) => {
  const hasStackWriteAccess = useHasStackWriteAccess();

  return useCallback(
    (run: Run, stack?: Stack) =>
      isRunDiscardable(run) && hasStackWriteAccess(stack || initialStack),
    [hasStackWriteAccess, initialStack]
  );
};

export default useCanDiscardRun;
